<template>
  <el-row class="container_self">
      <el-row class="table_parent">
          <el-row class="add_btn"><el-button type="primary" icon="el-icon-plus" size="mini" @click="createManager" v-if="permissions.indexOf(7)!=-1">新增客户</el-button></el-row>

          <el-row class="search_parent">
              <!-- <el-row>搜索</el-row> -->
              <el-input v-model="searchName" clearable placeholder="请输入客户名称" size="mini"></el-input>
              <el-button type="warning" icon="el-icon-search" size="mini" @click="search">搜索</el-button>
          </el-row>
          <el-row>
              <el-table :data="tableData"  style="width: 100%; margin-top: 10px"  v-loading="loading"  element-loading-text="加载中，请稍后"  element-loading-background="rgba(0, 0, 0, 0.8)">
                  <el-table-column prop="id" label="客户ID"  width="100" align="center" fixed></el-table-column>
                  <el-table-column prop="name" label="客户名称"  width="200" align="center" fixed></el-table-column>
                  <el-table-column label="clientId" width="120"  align="center" prop="clientId"></el-table-column>
                  <el-table-column label="登录账号" width="120"  align="center" prop="account"></el-table-column>
                  <!-- <el-table-column label="ip白名单" width="220"  align="center" prop="ipWhites"></el-table-column> -->
                  <el-table-column label="国家" align="center" prop="country"></el-table-column>
                  <el-table-column prop="state" label="所在州"  align="center" width="120"></el-table-column>
                  <el-table-column label="所在城市"  align="center" prop="city"></el-table-column>
                  <el-table-column label="地址一" width="220" prop="address1" align="center"></el-table-column>
                  <el-table-column label="地址二" width="220" prop="address2" align="center"></el-table-column>
                  <el-table-column prop="createTime" label="创建时间"  align="center"  width="200"></el-table-column>
                  <el-table-column prop="updateTime" label="更新时间"  align="center"  width="200"></el-table-column>
                  <el-table-column label="操作" fixed="right"  align="center" width="460">
                      <template slot-scope="scope">
                          <el-button type="warning" size="mini" @click="resetSecrect(scope.row.clientId)">重置密钥</el-button>
                          <el-button type="primary" size="mini" @click="editCustom(scope.row)" v-if="permissions.indexOf(6)!=-1">修改信息</el-button>
                          <el-button type="danger" size="mini" v-if="permissions.indexOf(9)!=-1" @click="deleteCustom(scope.row)">删除客户</el-button>
                          <el-button type="success" size="mini" v-if="permissions.indexOf(9)!=-1" @click="addGam(scope.row)">添加GAM账号</el-button>
                          <!-- <el-button type="primart" @click="addTest(scope.row)">添加</el-button> -->
                      </template>
                  </el-table-column>
              </el-table>

              <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100, 200]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
              </el-pagination>
          </el-row>
      </el-row>


      <el-dialog title="新增客户" :visible.sync="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
          <el-form :model="form" label-width="120px" :rules="rules" ref="ruleForm" size="mini" class="demo-ruleForm search_parent">
              <el-form-item label="客户名称" prop="name">
                  <el-input  v-model="form.name" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="登录账号" prop="account">
                  <el-input  v-model="form.account" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="登录密码" prop="password">
                  <el-input  v-model="form.password" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item   v-for="(item, index) in form.ipWhites"
                      :key="index+'_ip'" :label="'白名单ip地址 '+ (index+1)" class="can_addInput">
                  <el-input v-model="item.value" autocomplete="off"></el-input><el-button type="primary" round  icon="el-icon-plus" @click="addItem(form.ipWhites,item)" v-if="item.showAdd"></el-button><el-button type="primary" round  icon="el-icon-minus" @click="removeItem(form.ipWhites,item)" v-if="item.showMin"></el-button>
              </el-form-item>
              <el-form-item label="所在国家">
                  <el-input  v-model="form.country" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="所在州">
                  <el-input  v-model="form.state" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="所在城市">
                  <el-input  v-model="form.city" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="地址一">
                  <el-input  v-model="form.address1" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="地址二">
                  <el-input  v-model="form.address2" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="地区邮编">
                  <el-input  v-model="form.zipcode" autocomplete="off"></el-input>
              </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button @click="resetForm('ruleForm')" size="mini">取 消</el-button>
              <el-button type="primary" @click="submitForm('ruleForm')" size="mini">确 定</el-button>
          </div>
      </el-dialog>


      <el-dialog
          title="请妥善保存客户的clientSecret和clientId"
          :visible.sync="clientSecretDialog"
          width="30%"
          :before-close="handleClose">
          <el-alert
              title="警告！请自行复制以下的clientSecret和clientId并保存，丢失后将无法恢复"
              type="error"
              effect="dark"
              :closable="false">
          </el-alert>
          <el-row class="clienS" style="margin-top:60px;">clientSecret是：<el-alert :title="clientSecret" class="secret_alert" type="success"  :closable="false" ></el-alert></el-row>
          <el-row class="clienS">clientId是：<el-alert :title="clientId" type="success"  class="secret_alert"  :closable="false" ></el-alert></el-row>
          <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="handleClose">确 定</el-button>
          </span>
      </el-dialog>

      <el-dialog :title="string+'GAM账号'" :visible.sync="dialogFormVisibleAdd" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
          <el-form :model="formAdd" label-width="120px" :rules="rules1" ref="ruleForm1" size="mini" class="demo-ruleForm search_parent">
              <el-form-item label="所属客户">
                  <el-input v-model="formAdd.customerName" disabled></el-input>
              </el-form-item>
              <el-form-item label="GAM账号" prop="account">
                  <el-input v-model="formAdd.account"></el-input>
              </el-form-item>
              <el-form-item label="GAM密码" prop="password">
                  <el-input v-model="formAdd.password" type="password"></el-input>
              </el-form-item>
              <el-form-item label="GAM用户ID" prop="fetchUserId">
                  <el-input v-model="formAdd.fetchUserId"></el-input>
              </el-form-item>
              <el-form-item label="账号类型">
                  <el-select v-model="accountType"  @change="netWorkChange">
                      <el-option
                          v-for="(item, index) in networkCodeArr"
                          :value="item.code"
                          :label="item.label"
                          :key="index + '_' + item.code"
                      ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="是否启用">
                  <el-select v-model="formAdd.enabled">
                      <el-option :value="1" label="是"></el-option>
                      <el-option :value="0" label="否"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="NetworkCode" prop="networkCode">
                  <el-select v-model="formAdd.networkCode" disabled>
                      <el-option
                          v-for="(item, index) in networkCodeArr"
                          :value="item.code"
                          :label="item.code"
                          :key="item.code + '_' + index"
                          ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="百分比系数" prop="percentage">
                  <el-input v-model="formAdd.percentage"></el-input>
              </el-form-item>
              <el-form-item label="报告ID" prop="reportId">
                  <el-input v-model="formAdd.reportId"></el-input>
              </el-form-item>
              <el-form-item label="报告地址" prop="reportUrl">
                  <el-input v-model="formAdd.reportUrl" disabled></el-input>
              </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button @click="cancleFormAdd()" size="mini">取 消</el-button>
              <el-button type="primary" @click="submitFormAddGam('ruleForm1')" size="mini">确 定</el-button>
          </div>
      </el-dialog>
  </el-row>
</template>

<script>
  import {axiosGet,axiosPost} from '@/assets/ajaxFn'
  export default {
      data(){
          return{
              accountType:"",
              total:0,
              searchName:'',
              pageSize:50,
              tableData: [],
              loading:false,
              currentPage:1,
              dialogFormVisible:false,
              clientSecretDialog:false,
              dialogFormVisibleAdd:false,
              form:{
                  account:"",
                  password:'',
                  name:'',
                  country:'',
                  state:'',
                  city:'',
                  ext:'',
                  address1:'',
                  address2:'',
                  zipcode:'',
                  ipWhites:[{
                      value: '',
                      showAdd:true,
                      showMin:false
                  }],
              },
               rules:{
                  name: [
                      { required: true, message: '请输入客户名称', trigger: 'blur' },
                      { min: 2, max: 25, message: '长度在 3 到 25 个字符', trigger: 'blur' }
                  ],
                  account:[
                      { required: true, message: '请输入账号', trigger: 'blur' },
                  ],
                  password:[
                      // { required: true, message: '请输入密码', trigger: 'blur' },
                  ]
              },
              edit:false,
              customId:'',
              showclient:true,
              clientId:'',
              clientSecret:'',
              permissions:JSON.parse(sessionStorage.getItem('permission')),
              networkCodeArr:require('@/assets/networkcode.json'),
              string:"添加",
              formAdd:{
                  account: "",
                  customerId:"",
                  enabled: "",
                  fetchUserId: "",
                  id: "",
                  networkCode: "",
                  password: "",
                  percentage: "",
                  reportId: "",
                  reportUrl: "",
                  type:""
              },
              rules1:{
                  customerId:{ required: true, message: '选择客户', trigger: 'blur' },
                  account:{ required: true, message: '请输入登录账号', trigger: 'blur' },
                  fetchUserId:{ required: true, message: '请输入用户ID', trigger: 'blur' },
                  networkCode:{ required: true, message: '请输入登录密码', trigger: 'blur' },
                  percentage:{ required: true, message: '请输入百分比系数', trigger: 'blur' },
                  reportId:{ required: true, message: '请输入报告ID', trigger: 'blur' },
                  reportUrl:{ required: true, message: '请输入报告地址', trigger: 'blur' },
                  password:{required: true, message: '请输入登录密码', trigger: 'blur'}
              },
              needCheckPassword:true
          }
      },
      methods:{
        cancleFormAdd(){
          this.resetFormAdd();
          this.dialogFormVisibleAdd=false;
        },
          addTest(row){
              let add={
                  account:row.name,
                  customerId:row.id,
                  password:row.name
              }

              axiosPost('/api/customer/add_account',add,'JSON').then(res=>{
                  if(res.code==0){
                      this.$message({message:"ok",type:"success"})}
              })
          },
          resetFormAdd(){
              if(this.$refs.ruleForm1){
                  this.$refs.ruleForm1.resetFields();// 重置表单验证
              }
              // this.dialogFormVisible=false;
              this.formAdd={
                  customerName:"",
                  account: "",
                  customerId:"",
                  enabled: 1,
                  fetchUserId: "",
                  id: "",
                  networkCode: "",
                  password: "",
                  percentage:"",
                  reportId: "",
                  reportUrl: "",
                  type:""
              }
              this.accountType="";
          },
          addGam(row){
              this.dialogFormVisibleAdd=true;
              this.resetFormAdd();
              this.string="新增";
              this.formAdd.customerName=row.name;
              this.accountType="";
              this.formAdd.customerId=row.id;
          },
          resetSecrect(id){//重置密钥
              this.$confirm('此操作将重置用户密钥, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
              }).then(() => {
                axiosPost('/api/customer/reset_secret',{clientId:id},'JSON').then(res=>{
                  if(res.code==0){
                      this.clientSecret=res.data.clientSecret;
                      this.clientId=res.data.clientId;
                      this.clientSecretDialog=true;
                  }
                })
              }).catch(() => {

              });
          },
          handleSizeChange(val){
              this.pageSize=val;
              this.currentPage=1;
              this.getCustomList({currentPage:this.currentPage,pageSize:this.pageSize,keyword:this.searchName});
          },
          handleClose(){
              this.$confirm('请再次确认是否复制并保存了客户的clientSecret和clientId！',"警告",{
                  type: 'error',
                  confirmButtonText:'确定并关闭',
                  cancelButtonText:'取消'
              }).then(_ => {
                      this.clientSecretDialog=false;
                  })
              .catch(_ => {});
          },
          handleCurrentChange(val){
              this.currentPage=val;
              this.getCustomList({currentPage:this.currentPage,pageSize:this.pageSize,keyword:this.searchName});
          },
          search(){
              this.currentPage=1;
              this.pageSize=50;
              this.getCustomList({currentPage:1,pageSize:50,keyword:this.searchName});
          },
          createManager(){
              this.dialogFormVisible=true;
              this.needCheckPassword=true;
              this.rules.password=[ { required: true, message: '请输入密码', trigger: 'blur' }]
          },
          addItem(arr,item){//新增白名单ip
              if(arr.length>8){
                  this.$message({message:'最多可以添加9个',type:'error'});
                  return false;
              }
              arr.push({
                  value: '',
                  key: Date.now(),
                  showAdd:true,
                  showMin:true
              });
              arr[0].showAdd=false;
              arr[0].showMin=false;
              let index=arr.indexOf(item);
              if(index!=0){
                  arr[index].showAdd=false;
                  arr[index].showMin=true;
              }
          },
          removeItem(arr,item){
              let index=arr.indexOf(item)
              if(index!=0){
                  arr.splice(index,1);
                  arr[arr.length-1].showAdd=true;
              }

          },
          editCustom(item){
              this.needCheckPassword=false;
              axiosGet('/api/customer/info',{id:item.id}).then(res=>{
                  if(res.code==0){
                      this.form=res.data;
                      // this.form.ipWhites=res.data.ipWhites.split(',');
                      let ipArr=[];
                      if(res.data.ipWhites){
                         ipArr=res.data.ipWhites.split(',');
                      }
                      let newArr=[];
                      if (ipArr.length === 0) {
                          newArr.push({
                              value: '',
                              showAdd: true,
                              showMin: false
                          });
                          } else if (ipArr.length === 1) {
                              newArr.push({
                                  value: ipArr[0],
                                  showAdd: true,
                                  showMin: false
                              });
                          } else {
                              for (var i = 0; i < ipArr.length; i++) {
                                  var currentItem = {
                                      value: ipArr[i],
                                      showAdd: false,
                                      showMin: true
                                  };
                                  if (i === 0) {
                                      currentItem.showAdd = false;
                                      currentItem.showMin = false;
                                  } else if (i === ipArr.length - 1) {
                                      currentItem.showAdd = true;
                                      currentItem.showMin = true;
                              }
                              newArr.push(currentItem);
                          }
                      }
                      this.form.ipWhites=newArr;
                      this.customId=item.id;
                      this.showclient=false;
                      this.dialogFormVisible=true;
                      this.edit=true;
                  }
              })

          },
        submitForm(formName) {
           this.$refs[formName].validate((valid) => {
              if (valid) {
                  let whiteIp=[];
                  for(var i=0;i<this.form.ipWhites.length;i++){
                      whiteIp.push(this.form.ipWhites[i].value)
                  }
                  let addCustomRequest={
                      name:this.form.name,
                      country:this.form.country||'',
                      state:this.form.state||'',
                      city:this.form.city||'',
                      ext:this.form.ext||'',
                      address1:this.form.address1||'',
                      address2:this.form.address2||'',
                      zipcode:this.form.zipcode||'',
                      ipWhites:whiteIp.join(','),
                      account:this.form.account,
                      password:this.form.password
                  }
                  let url='',string='';
                  if(!this.edit){
                      addCustomRequest.ipWhites=whiteIp.join(',');
                      url='/api/customer/add';
                      string="添加";
                  }else{
                      url='/api/customer/update'
                      string="修改";
                      addCustomRequest.id=this.customId;
                  }
                  if(addCustomRequest.password){
                     axiosPost('/api/customer/update_password',{customerId:this.customId,password:addCustomRequest.password},"JSON").then(result=>{
                    })
                  }
                  axiosPost(url,addCustomRequest,'JSON').then(res=>{
                      if(res.code==0){
                          this.$message({message:`客户${string}成功`,type:'success'});
                          this.getCustomList({currentPage:1,pageSize:50});
                          this.dialogFormVisible=false;
                          this.accountType="";
                          this.edit=false;
                          this.showclient=true;
                          this.resetForm('ruleForm');
                          if(url=='/api/customer/add'){
                              if(res.data.clientSecret&&res.data.clientId){
                                  this.clientSecret=res.data.clientSecret;
                                  this.clientId=res.data.clientId;
                                  this.clientSecretDialog=true;
                              }
                          }

                      }
                  })

              } else {
                  console.log('error submit!!');
                  return false;
              }
              });
          },
         async submitFormAddGam(formName){
              const valid = await new Promise((resolve) => {
                  this.$refs[formName].validate((valid) => {
                      resolve(valid);
                  });
              });
              if(valid){
                  let url="/api/gam/account/add";
                  let code=this.accountType;
                  if(code==="21880406607"||code==="22902127475"||code==="22903129992"){
                    this.formAdd.type="google";
                  }else{
                    this.formAdd.type=code;
                  }
                  axiosPost(url,this.formAdd,'JSON').then(res=>{
                      if(res.code==0){
                          this.$message({message:'GAM账号添加成功',type:'success'});
                          this.accountType="";
                          this.dialogFormVisibleAdd=false;
                      }
                  })
              }
          },
          deleteCustom(row){
              this.$confirm("确定要删除 "+row.name+" 吗?", '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'error'
              }).then(() => {
                  axiosPost('/api/customer/delete',{id:row.id}).then(res=>{
                      if(res.code==0){
                          this.$message({message:'删除成功',type:"success"});
                          this.getCustomList({currentPage:1,pageSize:50,keyword:""});
                      }
                  })
              }).catch(() => {});
          },
          resetForm(formName) {
              this.$refs[formName].resetFields();
              this.dialogFormVisible=false;
              let _this=this;
              setTimeout(function(){//此定时器是为了防止页面UI抖动，可移除
                  _this.showclient=true;
                  _this.edit=false;
                  _this.form={
                      name:'',
                      country:'',
                      state:'',
                      city:'',
                      ext:'',
                      address1:'',
                      address2:'',
                      zipcode:'',
                      ipWhites:[{
                          value: '',
                          showAdd:true,
                          showMin:false
                      }]
                  }
              },500)

          },
          async getCustomList(params){
              this.loading=true;
              let res=await axiosGet('/api/customer/list',params);
              this.loading=false;
              if(res.code==0){
                      this.tableData=res.data.records;
                      this.total=res.data.total;
                  }
          },
          netWorkChange(val) {
            this.networkCodeArr.forEach((element)=>{
              if (val == element.code) {
                this.formAdd.networkCode = element.code;
                this.formAdd.reportUrl=element.url;
              }
            });
          },
      },
      mounted() {
          // this.getNetworkCode();
          this.getCustomList({currentPage:1,pageSize:50,keyword:""})
      },
  }
</script>
<style scoped>
.secret_alert {
  margin:15px 0;
  padding: 20px 10px;
}
  .clienS{
      font-size: 17px;
      margin: 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/customManager.vue